import React, { createContext, useContext, ReactNode } from 'react';

export type OnUpdateNoteActivity = (payload: { id: string; note: string }) => Promise<boolean>;
export type OnDeleteNoteActivity = (payload: { id: string }) => Promise<boolean>;

type CustomerActivityTimelineCtxValue = {
  onUpdateNoteActivity?: OnUpdateNoteActivity;
  onDeleteNoteActivity?: OnDeleteNoteActivity;
};

const CustomerActivityTimelineCtxDefault: CustomerActivityTimelineCtxValue = {
  onUpdateNoteActivity: undefined,
  onDeleteNoteActivity: undefined,
};

export const CustomerActivityTimelineCtx = createContext<CustomerActivityTimelineCtxValue>(
  CustomerActivityTimelineCtxDefault
);

export const CustomerActivityTimelineProvider = ({
  children,
  onUpdateNoteActivity,
  onDeleteNoteActivity,
}: {
  children: ReactNode;
  compact?: boolean;
  onUpdateNoteActivity?: OnUpdateNoteActivity;
  onDeleteNoteActivity?: OnDeleteNoteActivity;
}) => {
  return (
    <CustomerActivityTimelineCtx.Provider
      value={{
        onUpdateNoteActivity,
        onDeleteNoteActivity,
      }}
    >
      {children}
    </CustomerActivityTimelineCtx.Provider>
  );
};

export const useCustomerActivityTimelineCtx = () => {
  return useContext(CustomerActivityTimelineCtx);
};
